import { isPlatformBrowser } from "@angular/common";
import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges } from "@angular/core";
import { slugify } from "src/app/helpers/string-utils";

@Component({
    selector: "app-typeface-loader",
    template: "",
    standalone: true,
})
export class TypefaceLoaderComponent implements OnInit, OnChanges {
    @Input() fontFamily: string;
    private fontUri: string;
    private system = {
        "Arial": "Arial",
        "Times New Roman": "Times New Roman",
    }
    private legacy = {
        "typeface-regular": "Inter",
        "typeface-monospace": "Roboto Mono",
        "typeface-display": "Bebas Neue",
        "typeface-serif": "Source Serif Pro",
        "typeface-handwritten": "Kaushan Script",
    };
    private custom = {
        'Gotham': '/assets/fonts/gotham.css',
        'Gotham Book': '/assets/fonts/gotham-book.css',
        'Bariol Bold': '/assets/fonts/bariol-bold.css',
        'Proxima Nova': '/assets/fonts/proxima-nova.css',
        "Barlow": "/assets/fonts/barlow.css",
    };

    constructor(@Inject(PLATFORM_ID) private platform,) {}

    ngOnInit(): void {
        if(isPlatformBrowser(this.platform) && this.fontFamily) {
            this.update();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(isPlatformBrowser(this.platform) && this.fontFamily) {
            this.update();
        }
    }

    update() {

        // System font support.
        if(Object.keys(this.system).includes(this.fontFamily)) {
            return;
        }

        // Legacy support.
        if(Object.keys(this.legacy).includes(this.fontFamily)) {
            this.fontFamily = this.legacy[this.fontFamily];
        }

        // Custom font support.
        if(Object.keys(this.custom).includes(this.fontFamily)) {
            let link = document.getElementById(`fontLink-${slugify(this.fontFamily)}`);
            if (!link) {
                link = document.createElement("link");
                link.id = `fontLink-${slugify(this.fontFamily)}`;
                link.setAttribute("rel", "stylesheet");
                link.setAttribute("href", this.custom[this.fontFamily]);
                document.head.appendChild(link);
            }
            return;
        }

        this.fontUri = `https://fonts.googleapis.com/css?family=${this.fontFamily.replace(
            " ",
            "+"
        )}:300,400,500,600,700&display=swap`;
        let pos = this.fontFamily.indexOf(":");
        if (pos > 0) {
            this.fontFamily = this.fontFamily.substring(0, pos);
        }
        let link = document.getElementById(`fontLink-${slugify(this.fontFamily)}`);
        if (!link) {
            link = document.createElement("link");
            link.id = `fontLink-${slugify(this.fontFamily)}`;
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("href", this.fontUri);
            document.head.appendChild(link);
        }
    }
}
